<template>
  <div class="order-page">
    <Button type="primary" icon="plus-round" @click="edit(-1)">{{$t('Order.New_Order')}}</Button>
    <!-- <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(-1)">{{$t('Order.New_Order')}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(-1)" disabled>{{$t('Order.New_Order')}}</Button> -->
    <br>
    <i-Col span="5">
      <Select class="text" v-model="Valid" :value="Valid">
        <Option value="1" key= 1>{{$t('Order.No_scheduling')}}</Option>
        <Option value="2" key= 2>{{$t('Order.Not_production')}}</Option>
        <Option value="3" key= 3>{{$t('Order.Producting')}}</Option>
        <Option value="4" key= 4>{{$t('Order.Case_closed')}}</Option>
      </Select>
    </i-Col>
    <i-Col span="5">
    <Input class="search" v-model="search1" :placeholder="$t('Order.orderNo')"></Input>
    </i-Col>
    <i-Col span="5">
    <Input class="search" v-model="search2" :placeholder="$t('Order.customer')"></Input>
    </i-Col>
    <i-Col span="6">
    <Input class="search" v-model="search3" :placeholder="$t('Order.salesman')">
       <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
      <Button slot="append" icon="refresh" @click="handleReset()"></Button>
    </Input>
    </i-Col>
    <br>
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <br v-if="datas.length === 0">
    <Card class="order-card" v-for="(order,index) in datas" :key="order.orderID">
      <p slot="title">
        <Row>
          <Col span="5">{{$t('Order.orderNo')}}:{{order.orderNo}}</Col>
          <Col span="5">{{$t('Order.customer')}}:{{order.customer}}</Col>
          <Col span="5">{{$t('Order.ordersTime')}}:{{order.ordersTime}}</Col>
          <Col span="5">{{$t('Order.salesman')}}:{{order.salesman}}</Col>
          <Col span="4">
            <Button size="small" type="primary" v-if="permissions === true && order.Ordervalid === 1" @click="edit(order.orderID)">{{$t('Order.edit')}}</Button>
            <Button size="small" type="primary" v-if="permissions !== true || order.Ordervalid === 0" @click="edit(order.orderID)" disabled>{{$t('Order.edit')}}</Button>
            <Button size="small" type="error" v-if="permissions === true && order.check === 0 && order.Ordervalid === 1" @click="remove(index)">{{$t('Order.delete')}}</Button>
            <Button size="small" type="error" v-if="permissions !== true || order.check === 1" @click="remove(index)" disabled>{{$t('Order.delete')}}</Button>
          </Col>
        </Row>
      </p>
      <Table size="small" class="order-table" highlight-row stripe border :columns="columns" :data="order.orderProducts"></Table>
    </Card>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Order',
  data () {
    return {
      columns: [
        {
          title: this.$t('Order.status'),
          key: 'status1',
          width: 100,
          render: (h, params) => {
            if (params.row.valid === 0) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.change(params.row.id)
                  }
                }
              }, params.row.status2)
            } else if (params.row.PPValid === 1 && params.row.CPValid === 1) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'OrderPlan'})
                  }
                }
              }, params.row.status2)
            } else if (params.row.PPValid === 1) {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'CollectorPlan'})
                  }
                }
              }, params.row.status2)
            } else {
              return h('Button', {
                props: {
                  size: 'small',
                  type: params.row.status1
                },
                on: {
                  click: () => {
                    this.$router.push({'name': 'ProductionPlan'})
                  }
                }
              }, params.row.status2)
            }
          }
        },
        { title: this.$t('Order.productNo'), key: 'productNo' },
        { title: this.$t('Order.num'), key: 'num' },
        { title: this.$t('Order.unit'), key: 'unit' },
        { title: this.$t('Order.attritionRate'), key: 'attritionRate' },
        { title: this.$t('Order.deliveryTime'), key: 'deliveryTime' },
        { title: this.$t('Order.remark'), key: 'remark' }
      ],
      datas: [],
      datasList: [],
      totalList: [],
      temp1: [],
      temp2: [],
      temp3: [],
      search1: '',
      search2: '',
      search3: '',
      Valid: '',
      products: [],
      permissions: false
    }
  },
  computed: {
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : index
      this.$router.push({ name: 'OrderEdit', params: { id } })
    },
    remove (index) {
      if (confirm(this.$t('Order.delete_message'))) {
        this.$api.order.delete(this.datas[index].orderID).then(() => {
          this.datas.splice(index, 1)
        })
      }
    },
    change (id) {
      if (confirm(this.$t('Order.change_message'))) {
        this.$api.order.change(id).then(() => {
          for (let i = 0; i < this.datas.length; i++) {
            for (let j = 0; j < this.datas[i].orderProducts.length; j++) {
              if (id === this.datas[i].orderProducts[j].id) {
                this.datas[i].orderProducts[j].status1 = 'primary'
                this.datas[i].orderProducts[j].status2 = this.$t('Order.Producting')
                this.datas[i].orderProducts[j].valid = 1
              }
            }
          }
        })
      }
    },
    handleSearch () {
      this.datas = []
      this.temp1 = []
      this.temp2 = []
      this.temp3 = []
      if (this.Valid === '1') {
        for (let i = 0; i < this.datasList.length; i++) {
          let p = this.datasList[i]
          for (let j = 0; j < p.orderProducts.length; j++) {
            if (p.orderProducts[j].PPValid === 0 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
              this.temp3.push(p)
              break
            }
          }
        }
      } else if (this.Valid === '2') {
        for (let i = 0; i < this.datasList.length; i++) {
          let p = this.datasList[i]
          for (let j = 0; j < p.orderProducts.length; j++) {
            if (p.orderProducts[j].PPValid === 1 && p.orderProducts[j].CPValid === 0 && p.orderProducts[j].Closedtime === '') {
              this.temp3.push(p)
              break
            }
          }
        }
      } else if (this.Valid === '3') {
        for (let i = 0; i < this.datasList.length; i++) {
          let p = this.datasList[i]
          for (let j = 0; j < p.orderProducts.length; j++) {
            if (p.orderProducts[j].PPValid === 1 && p.orderProducts[j].CPValid === 1 && p.orderProducts[j].Closedtime === '') {
              this.temp3.push(p)
              break
            }
          }
        }
      } else if (this.Valid === '4') {
        for (let i = 0; i < this.totalList.length; i++) {
          let p = this.totalList[i]
          for (let j = 0; j < p.orderProducts.length; j++) {
            if (p.orderProducts[j].Closedtime !== '') {
              this.temp3.push(p)
            }
          }
        }
      } else {
        this.temp3 = this.datasList
      }
      for (let i = 0; i < this.temp3.length; i++) {
        let p = this.temp3[i]
        if (this.search1 === '') {
          this.temp1 = this.temp3
          break
        } else if (p.orderNo.toLowerCase().indexOf(this.search1.toLowerCase()) !== -1) {
          this.temp1.push(p)
        }
      }
      for (let i = 0; i < this.temp1.length; i++) {
        let p = this.temp1[i]
        if (this.search2 === '') {
          this.temp2 = this.temp1
          break
        } else if (p.customer.toLowerCase().indexOf(this.search2.toLowerCase()) !== -1) {
          this.temp2.push(p)
        }
      }
      for (let i = 0; i < this.temp2.length; i++) {
        let p = this.temp2[i]
        if (this.search3 === '') {
          this.datas = this.temp2
          break
        } else if (p.salesman.toLowerCase().indexOf(this.search3.toLowerCase()) !== -1) {
          this.datas.push(p)
        }
      }
      if (this.Valid === '4') {
        for (let i = 0; i < this.datas.length; i++) {
          for (let j = 0; j < this.datas[i].orderProducts.length; j++) {
            if (this.datas[i].orderProducts[j].unit === 1) {
              this.datas[i].orderProducts[j].unit = this.$t('Order.Meter')
            } else if (this.datas[i].orderProducts[j].unit === 2) {
              this.datas[i].orderProducts[j].unit = this.$t('Order.Yard')
            } else if (this.datas[i].orderProducts[j].unit === 3) {
              this.datas[i].orderProducts[j].unit = this.$t('Order.Gross')
            }
            if (this.datas[i].orderProducts[j].valid === 0) {
              this.datas[i].orderProducts[j].status1 = 'success'
              this.datas[i].orderProducts[j].status2 = this.$t('Order.Case_closed')
              this.datas[i].check = 1
            } else if (this.datas[i].orderProducts[j].PPValid === 1 && this.datas[i].orderProducts[j].CPValid === 1) {
              this.datas[i].orderProducts[j].status1 = 'primary'
              this.datas[i].orderProducts[j].status2 = this.$t('Order.Producting')
              this.datas[i].check = 1
            } else if (this.datas[i].orderProducts[j].PPValid === 1) {
              this.datas[i].orderProducts[j].status1 = 'warning'
              this.datas[i].orderProducts[j].status2 = this.$t('Order.Not_production')
              this.datas[i].check = 1
            } else {
              this.datas[i].orderProducts[j].status1 = 'error'
              this.datas[i].orderProducts[j].status2 = this.$t('Order.No_scheduling')
            }
          }
        }
      }
      // console.log(this.datas)
    },
    handleReset () {
      this.datas = this.datasList
      this.Valid = ''
      this.search1 = ''
      this.search2 = ''
      this.search3 = ''
    }
  },
  mounted () {
    Api.product.list().then(res => {
      this.products = res.products
    })
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'order' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    // console.log(to.fullPath)
    Api.order.list().then(res => {
      next(vm => {
        let d = []
        vm.datas = res.orderInfos
        vm.datasList = res.orderInfos
        vm.totalList = res.orderInfos
        for (let i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].Ordervalid === 1) {
            vm.datas[i].check = 0
            for (let j = 0; j < vm.datas[i].orderProducts.length; j++) {
              if (vm.datas[i].orderProducts[j].unit === 1) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Meter')
              } else if (vm.datas[i].orderProducts[j].unit === 2) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Yard')
              } else if (vm.datas[i].orderProducts[j].unit === 3) {
                vm.datas[i].orderProducts[j].unit = vm.$t('Order.Gross')
              }
              if (vm.datas[i].orderProducts[j].valid === 0) {
                vm.datas[i].orderProducts[j].status1 = 'success'
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Case_closed')
                vm.datas[i].check = 1
              } else if (vm.datas[i].orderProducts[j].PPValid === 1 && vm.datas[i].orderProducts[j].CPValid === 1) {
                vm.datas[i].orderProducts[j].status1 = 'primary'
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Producting')
                vm.datas[i].check = 1
              } else if (vm.datas[i].orderProducts[j].PPValid === 1) {
                vm.datas[i].orderProducts[j].status1 = 'warning'
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.Not_production')
                vm.datas[i].check = 1
              } else {
                vm.datas[i].orderProducts[j].status1 = 'error'
                vm.datas[i].orderProducts[j].status2 = vm.$t('Order.No_scheduling')
              }
            }
            d.push(vm.datas[i])
          }
        }
        vm.datas = d
        vm.datasList = d
      })
    })
  }
}
</script>
<style>
  .order-page {
    padding: 10px;
  }
  .order-card {
    margin-top: 20px;
  }
</style>





// WEBPACK FOOTER //
// List.vue?2fa54ad0